// data structure: { receipt: Base64 string | undefined, error: string | undefined }

export default function (username) {
  return this.sendEventWithCallback(
    'subscription.restore.ios',
    { username }
  ).then(data => {
    // shortcut
    if (data.receipt || data.error) {
      return data
    }

    return Promise.reject(
      new Error(this.ERROR_UNKNOWN)
    )
  })
}
